import {observer, React} from '@api'
import {useBuilderCardStore, useStores} from '@modules'
import * as css from './BuilderCard.css'
import {Icon} from '@blueprintjs/core'

export const AdditionalIcons = observer(function AdditionalIcons({}: { className?: any }) {
  const {catalog: {cardSize, defaultCardSize, features}} = useStores(),
    store = useBuilderCardStore(),
    size = Math.max(14, Math.round(cardSize * 16 / defaultCardSize)),
    cardIcons = features?.card?.icons

  return !_.isEmpty(cardIcons) ? (
    <div data-icon-lod={store?.levelOfDetail} className={css.iconWrapper}>
      {cardIcons.map(icon => _.get(store?.data, icon.field) ? <Icon key={icon.name} className={css.star} icon={icon.name ?? 'star'} iconSize={size}/> : null).filter(_.identity)}
    </div>
  ) : null
})



// WEBPACK FOOTER //
// ./src/modules/catalog/product/productCard/components/BuilderCard/AdditionalIcons.tsx